// extracted by mini-css-extract-plugin
export default {"container":"DeleteModal_container__srhlb","ctn":"DeleteModal_ctn__wxe8a","buttons":"DeleteModal_buttons__zrhCH"};